// export const validateEmail = /[A-Za-z0-9_.]+@([dD]ell(team)?).com/;
export const validateEmail = /[A-Za-z0-9_.]+@(([dD]ell(team)?).com|labldi\.com\.br)/;
export const validateInput =
  /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ',?!.\s]+$/;
